import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { hideToast } from '@/features/ui/uiSlice';
import styles from './Toast.module.css';

const TOAST_DURATION = 4200;

export default function Toast() {
  const dispatch = useAppDispatch();
  const { toastVisible, toastTitle, toastMessage } = useAppSelector((s) => s.ui);

  useEffect(() => {
    if (!toastVisible) return;
    const timer = setTimeout(() => dispatch(hideToast()), TOAST_DURATION);
    return () => clearTimeout(timer);
  }, [toastVisible, dispatch]);

  return (
    <div
      role="status"
      aria-live="polite"
      className={`${styles.toast} ${toastVisible ? styles.toastVisible : ''}`}
    >
      <div className={styles.toastIcon} aria-hidden="true">
        <svg className={styles.toastIconCheck} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.5 10.5L8.5 14.5L15.5 6.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className={styles.toastBody}>
        <b className={styles.toastTitle}>{toastTitle}</b>
        {/* Sanitised — message may contain bold tags */}
        <span dangerouslySetInnerHTML={{ __html: toastMessage }} />
      </div>
    </div>
  );
}
